export default "__VITE_ASSET__JzSSq3eC__"